module.exports = __webpack_public_path__ + "img/icon-warning-flood-yellow.a8c9226e.svg";